<template>
  <v-form ref="form" @submit.prevent="changePassword">
    <v-card flat>
      <v-card-title>
        {{ $t('password_change') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="passwords.current_password"
              :error-messages="errors.current_password"
              :append-icon="isCurrentPasswordHidden ? 'mdi-eye' : 'mdi-eye-off'"
              :type="isCurrentPasswordHidden ? 'password' : 'text'"
              :label="$t('current_password')"
              name="current_password"
              autofocus
              @click:append="isCurrentPasswordHidden = !isCurrentPasswordHidden"
              @input="clearErrors('current_password')"
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="passwords.new_password"
              :error-messages="errors.new_password"
              :append-icon="isNewPasswordHidden ? 'mdi-eye' : 'mdi-eye-off'"
              :type="isNewPasswordHidden ? 'password' : 'text'"
              :label="$t('new_password')"
              name="new_password"
              @click:append="isNewPasswordHidden = !isNewPasswordHidden"
              @input="clearErrors('new_password')"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          :disabled="isRequestPending"
          :loading="isRequestPending"
          color="primary"
          type="submit"
          class="mx-2"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formMixin from '../mixins/form-mixin';
import userService from '../api/user-service';
import { mapErrorsToInputs } from '../util/forms';
import eventBus, { OPEN_SNACKBAR } from '../util/event-bus';

export default {
  name: 'PasswordChangeForm',

  mixins: [formMixin],

  data() {
    return {
      isNewPasswordHidden: true,
      isCurrentPasswordHidden: true,
      isRequestPending: false,
      passwords: {
        current_password: '',
        new_password: '',
      },
      errors: {},
    };
  },

  methods: {
    clearErrors(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },

    async changePassword() {
      this.isRequestPending = true;

      try {
        await userService.changeCurrentUserPassword(this.passwords);
        eventBus.$emit(OPEN_SNACKBAR, this.$t('password_was_changed'));
        this.passwords = {
          current_password: '',
          new_password: '',
        };
      } catch (e) {
        this.errors = mapErrorsToInputs(e);
      }

      this.isRequestPending = false;
    },
  },
};
</script>
